import { useEffect, useState } from 'react';
import '../../styles/login.scss';
import '../../styles/app.css';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { DerbySoftMUItheme } from '../../styles/muiTheme';
import { Layout } from 'antd';
import Sidebar from '../Sidebar';
import { SideBarStatusProvider } from '../../store/sidebarContext';
import welcome from '../../styles/assets/password.png';
import ButtonDinamyc from '../ButtonDinamyc';
import { pingLogOut } from '../../helpers/ping';
import { useSession } from '../../store/sessionContext';
import moment from 'moment';
import { handleBackButton } from '@helpers/axiosService';

const theme = createMuiTheme(DerbySoftMUItheme);

const Forbidden = () => {
  const { Content } = Layout;

  const [subMenuStatus, setSubMenuStatus] = useState<boolean>(false);
  const [errorCode, setErrorCode] = useState<string>('');
  const [hasFocus, setHasFocus] = useState<boolean>(false);
  const [date, setDate] = useState<string>('');

  useEffect(() => {
    const data: any[] = window.location.pathname.split('/');
    data.forEach((value: any, index: number) => {
      if (/\d/.test(value)) {
        setErrorCode(value);
      }
    });
    setDate(moment().format('YYYY.DD.MM'));
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <Layout className='site-layout'>
        <SideBarStatusProvider>
          <Sidebar
            subMenuStatus={subMenuStatus}
            setSubMenuStatus={setSubMenuStatus}
            setHasFocus={setHasFocus}
            hasFocus={hasFocus}
            short={true}
            showMenu={false}
          />
          <Layout className='site-layout'>
            <Content>
              <div className='container'>
                <section className='p-10'>
                  <img src={welcome} alt='content suite title' />
                </section>
                <section className='container-message'>
                  <div>
                    <b className='bold-message'>You don't have permission to view this page.</b>
                  </div>
                  <div className='p-top'>
                    <p className='error-message'>Please contact your administrator.</p>
                  </div>
                  <ButtonDinamyc message='Back to Home' classes='buttonContactUs' action={handleBackButton} />
                </section>

                <section className='error-container'>
                  <div className='error-container'>
                    <p className='error-code'>
                      {date}_{errorCode}
                    </p>
                  </div>
                </section>
              </div>
            </Content>
          </Layout>
        </SideBarStatusProvider>
      </Layout>
    </MuiThemeProvider>
  );
};

export default Forbidden;
